import { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    useEffect(() => {
      document.title = 'Grid Monitor Service';
    }, []),
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Grid Monitor Service
        </p>
      </header>
    </div>
  );
}

export default App;
